import React, { useEffect, useState } from 'react'
import './TourPage.sass'
import getDoc from '../../../utils/db/getDoc'
import { NavLink, withRouter } from 'react-router-dom'
import TourTag from '../TourTag/TourTag'
import { isEmpty } from 'lodash'
import parse from 'html-react-parser'
import Icon from '../../../ui/Icon/Icon'
import promiseAllValues from '../../../utils/promiseAllValues'
import Carousel from '../../../ui/Carousel/Carousel'
import Button from '../../../ui/Button/Button'
import ApiContactForm from '../ApiContactForm/ApiContactForm'
import regAnalyticReq from '../regAnalyticReq'

function TourPage({ ...router }) {
  const [tourData, setTourData] = useState(null)
  const tourId = router.match.params.id
  const [showContactUsForm, setShowContactUsForm] = useState(false)

  useEffect(() => {
    promiseAllValues({
      tourData: getDoc({
        path: 'tours',
        docId: tourId,
      }),
      settings: getDoc({
        path: 'settings',
        docId: '0tOG33b4DzEfG8BS9x7x',
      }),
    }).then((data) => {
      regAnalyticReq({
        projectId: 'bXy8m4F5kHXNU3ADr43Z',
        counterType: 'tour',
        eventType: 'watch',
        offerId: tourId,
        offerType: 'tour',
        offerLink: `https://hotel.iterrainc.ru/tours/${tourId}`,
      })
        .then((r) => {
          console.log('🚀 ~ TourPage ~ r:', r)
        })
        .catch((e) => {
          console.log('🚀 ~ TourPage ~ e:', e)
        })
      setTourData({ ...data.tourData, settings: data.settings })
    })
  }, [])

  const showPhoneNumber = () => {
    regAnalyticReq({
      projectId: 'bXy8m4F5kHXNU3ADr43Z',
      counterType: 'contacts',
      eventType: 'phoneClick',
      offerId: tourId,
      offerType: 'tour',
      offerLink: `https://hotel.iterrainc.ru/tours/${tourId}`,
    })
      .then((r) => {
        console.log('🚀 ~ TourPage contact clicked~ r:', r)
      })
      .catch((e) => {
        console.log('🚀 ~ TourPage contact clicked ~ e:', e)
      })

    document.getElementsByClassName('HiddenBlock')[0].style.display = 'none'
  }

  const showMessanger = (messanger) => {
    regAnalyticReq({
      projectId: 'bXy8m4F5kHXNU3ADr43Z',
      counterType: 'contacts',
      eventType: `${messanger}Click`,
      offerId: tourId,
      offerType: 'tour',
      offerLink: `https://hotel.iterrainc.ru/tours/${tourId}`,
    })
      .then((r) => {
        console.log('🚀 ~ TourPage contact clicked~ r:', r)
      })
      .catch((e) => {
        console.log('🚀 ~ TourPage contact clicked ~ e:', e)
      })
  }

  return !isEmpty(tourData) ? (
    <div className="Api-TourPage">
      <div className="Api-TourPage-Container">
        <div className="Api-TourBreadcrumbs">
          <NavLink to="/tours">Туры по Кольскому полуострову</NavLink>{' '}
          <Icon name="long-arrow-right" /> <span>{tourData.ru.title}</span>
        </div>
        <div className="Api-TourPage-Carousel">
          <Carousel
            element={`tour-${tourId}`}
            options={{
              type: 'carousel',
              perView: 1,
              ...(!isEmpty(tourData.ru.photoLinks.split('\n'))
                ? { autoplay: 5000 }
                : {}),
              focusAt: 'center',
              gap: -16,
              peek: {
                before: 250,
                after: 250,
              },
              useDots: true,
              useArrows: true,
              breakpoints: {
                576: {
                  gap: 0,
                  peek: { before: 0, after: 0 },
                },
              },
            }}
          >
            {tourData.ru.photoLinks.split('\n')
              ? tourData.ru.photoLinks.split('\n').map((p) => (
                  <a data-fancybox={`gallery-${tourId}`} href={p}>
                    <img src={p} alt={tourData.ru.title} />
                  </a>
                ))
              : null}
          </Carousel>
        </div>
        <div className="Api-TourPage-Content">
          <div className="Content">
            <p className="Title">{tourData.ru.title}</p>
            <div className="Tags">
              <TourTag
                icon="calendar-alt"
                title="Сезон"
                value={tourData.ru.season}
              />
              <TourTag
                icon="clock"
                title="Продолжительность"
                value={tourData.ru.duration}
              />
            </div>
            <p className="Description">{parse(tourData.ru.description)}</p>
            <p className="Program">
              <p className="BTitle">Программа тура</p>
              {parse(tourData.ru.program)}
            </p>
          </div>
          <div className="ContactBlock">
            <p className="Title">Забронировать тур</p>
            <div className="Price">
              {tourData.ru.price[0].value2}{' '}
              <span className="smallTitle">{tourData.ru.price[0].desc}</span>
            </div>
            <div className="Contacts">
              <a href="tel:" className="PhoneButton">
                <Icon name="mobile" weight={'regular'} />{' '}
                {tourData.settings.phone}
                <div className="HiddenBlock" onClick={showPhoneNumber}>
                  Показать номер
                </div>
              </a>
            </div>
            <Button
              title={'Запустить приключение'}
              fill="accent"
              theme="solid"
              type="button"
              icon="play"
              style={{ background: '#647263' }}
              iconWeight="solid"
              onClick={() => setShowContactUsForm(true)}
            />
            {showContactUsForm && (
              <ApiContactForm
                tourName={tourData.ru.title}
                onClose={() => setShowContactUsForm(false)}
              />
            )}
            <div className="SocialContacts">
              Написать в мессенджеры
              <div className="SocialContacts-Container">
                <a
                  href={tourData.settings.tmLink}
                  className="ContactButton Telegram"
                  target="blank"
                  onClick={() => showMessanger('tg')}
                >
                  <Icon name="telegram" weight={'brand'} />
                  Telegram
                </a>
                <a
                  href={tourData.settings.whatLink}
                  className="ContactButton Whatsapp"
                  target="blank"
                  onClick={() => showMessanger('what')}
                >
                  <Icon name="telegram" weight={'brand'} />
                  Whatsapp
                </a>
              </div>
            </div>
          </div>
          <div className="Include">
            <div className="WhatInclude">
              <p className="BTitle">В стоимость включено</p>
              {parse(tourData.ru.include)}
            </div>
            <div className="WhatToCare">
              <p className="BTitle">Что брать с собой</p>
              {parse(tourData.ru.prepare)}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    'loading'
  )
}

export default withRouter(TourPage)
